import {connect} from 'react-redux';
import * as items from 'items/actions/items';
import * as invoice from 'invoices/actions/invoices';
import React, {Component, Fragment} from 'react';
import autobind from 'autobind-decorator';
import {Input, Label} from 'reactstrap';

@connect(
    state => {
        return {
            items: state.items
        }
    },
    dispatch => {
        return {
            changeCurrentMonth: (month, callback) => dispatch(items.changeMonth(month, callback))
        }
    }
)
export class ChangeMonth extends Component {

    @autobind
    changeCurrentMonth(event) {
        const value = event.target.value;
        this.props.changeCurrentMonth(value, this.props.callback);
    }

    render() {
        const currentMonth = this.props.items.currentMonth;
        const monthList = [
            'Gesamt',
            'Januar',
            'Februar',
            'März',
            'April',
            'Mai',
            'Juni',
            'Juli',
            'August',
            'September',
            'Oktober',
            'November',
            'Dezember'
        ];
        return (
            <Fragment>
                <Label>
                    Monat
                </Label>
                <Input type="select"
                       onChange={this.changeCurrentMonth}
                       value={currentMonth}
                >
                    {
                        monthList.map(
                            (month, index) =>
                                <option key={`month_${month}`} value={index}>
                                    {month}
                                </option>
                        )
                    }
                </Input>
            </Fragment>
        )
    }
}

function range(start, end) {
    const reverse = start < end;
    const size = Math.abs(end - start) + 1;
    const startsAt = !reverse ? end : start;
    if(size > 0) {
        const result = [...Array(size).keys()].map(i => i + startsAt);
        return result
    } 
    return []
}

@connect(
    state => {
        return {
            items: state.items
        }
    },
    dispatch => {
        return {
            changeCurrentYear: (year, callback) => dispatch(items.changeYear(year, callback))
        }
    }
)
export class ChangeYear extends Component {

    @autobind
    changeCurrentYear(event) {
        const value = event.target.value;
        this.props.changeCurrentYear(value, this.props.callback);
    }

    render() {
        const currentYear = this.props.items.currentYear;
        const yearList = range(2017, (new Date()).getFullYear());
        return (
            <Fragment>
                {
                    !this.props.nolabel &&
                    <Label>
                        Jahr
                    </Label>
                }
                <Input type="select"
                       onChange={this.changeCurrentYear}
                       value={currentYear}
                >
                    {
                        yearList.map(
                            year =>
                                <option key={`year_${year}`} value={year}>
                                    {year}
                                </option>
                        )
                    }
                </Input>
            </Fragment>
        )
    }
}

@connect(
    state => {
        return {
            items: state.items
        }
    },
    dispatch => {
        return {
            changeCurrentQuarter: (quarter, callback) => dispatch(items.changeQuarter(quarter, callback))
        }
    }
)
export class ChangeQuarter extends Component {

    @autobind
    changeCurrentQuarter(event) {
        const value = event.target.value;
        this.props.changeCurrentQuarter(value, this.props.callback);
    }

    render() {
        const currentQuarter = this.props.items.currentQuarter;
        const quaterList = [
            {
                id: 0,
                name: 'Gesamt'
            },
            {
                id: 1,
                name: '1. Quartal'
            },
            {
                id: 2,
                name: '2. Quartal'
            },
            {
                id: 3,
                name: '3. Quartal'
            },
            {
                id: 4,
                name: '4. Quartal'
            },
        ];
        return (
            <Fragment>
                <Label>
                    Quartal
                </Label>
                <Input type="select"
                       onChange={this.changeCurrentQuarter}
                       value={currentQuarter}
                >
                    {
                        quaterList.map(
                            quarter =>
                                <option key={`quater_${quarter.id}`} value={quarter.id}
                                >
                                    {quarter.name}
                                </option>
                        )
                    }
                </Input>
            </Fragment>
        )
    }
}

@connect(
    state => {
        return {
            status: state.invoices.status
        }
    },
    dispatch => {
        return {
            changeStatus: (status) => dispatch(invoice.changeStatus(status))
        }
    }
)
export class ChangeStatus extends Component {

    @autobind
    changeStatus(event) {
        const value = event.target.value;
        this.props.changeStatus(value);
    }

    render() {
        const {status} = this.props;
        const statusList = [
            {
                value: '',
                label: 'Alle'
            },
            {
                value: 0,
                label: 'Ausstehend'
            },
            {
                value: 1,
                label: 'Bezahlt'
            },
        ];
        return (
            <Fragment>
                <Label>
                    Status
                </Label>
                <Input type="select"
                       onChange={this.changeStatus}
                       value={status}
                >
                    {
                        statusList.map(
                            status =>
                                <option key={`status-option-${status.value}`} value={status.value}
                                >
                                    {status.label}
                                </option>
                        )
                    }
                </Input>
            </Fragment>
        )
    }
}
